import { api, el } from "../../ui/dom";
import { icon } from "../../ui/icons";
import { card, chip, table } from "../../ui/record";

// A person's paid time off and their week (brief 1E-11): their balance under each of their
// policies, and, for people with Payroll at View and Sees financials, this week's summary (as on
// Home Care › Payroll's Week summary, with its checks).

interface PersonPto {
  balances: { policy: string; earned: string; used: string; balance: string }[];
  week: {
    week: { label: string };
    row: {
      patients: number;
      visits: number;
      clocked: string;
      earned: string;
      mileage: string;
      average: string;
      checks: { kind: "over" | "under"; words: string }[];
      shortfall: string | null;
    } | null;
  } | null;
}

export async function ptoCard(host: HTMLElement, personId: string) {
  const res = await api<PersonPto>("GET", `/api/people/${encodeURIComponent(personId)}/pto`);
  if (!res.ok) return;
  const v = res.body;
  const parts: HTMLElement[] = [];
  if (v.balances.length) {
    const c = card(
      el("span", {}, icon("calendar"), " Paid time off and sick leave"),
      null,
      [],
      table(
        [
          { h: "Policy", f: (b) => el("b", {}, b.policy) },
          { h: "Earned", num: true, f: (b) => b.earned },
          { h: "Used", num: true, f: (b) => b.used },
          { h: "Balance", num: true, f: (b) => el("b", {}, b.balance) },
        ],
        v.balances,
        undefined,
        "Balances",
      ),
    );
    c.setAttribute("aria-label", "Paid time off and sick leave");
    parts.push(c);
  }
  if (v.week) {
    const r = v.week.row;
    const c = card(
      el("span", {}, icon("people"), ` This week · ${v.week.week.label}`),
      null,
      [],
      r
        ? el(
            "div",
            {},
            el(
              "dl",
              { class: "kv" },
              ...(
                [
                  ["Patients", String(r.patients)],
                  ["Visits", String(r.visits)],
                  ["Clocked", r.clocked],
                  ["Earned", r.earned],
                  ["Mileage", r.mileage],
                  ["Average per hour", r.average],
                ] as [string, string][]
              ).flatMap(([k, x]) => [el("dt", {}, k), el("dd", {}, x)]),
            ),
            el(
              "p",
              { style: "margin:8px 0 0" },
              ...(r.checks.length
                ? r.checks.map((x) => chip(x.words, x.kind === "over" ? "warn" : "bad"))
                : [chip("OK", "ok")]),
            ),
          )
        : el("p", { class: "muted" }, "No validated visits this week yet."),
    );
    c.setAttribute("aria-label", "This week");
    parts.push(c);
  }
  host.replaceChildren(...(parts.length ? [el("div", { class: "recgrid" }, ...parts)] : []));
}
